<template>
  <div>
    <div class="policy_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <span>
            <div class="mobiFaq">
              <h2 class="mobiTitle sm text_color">Podmínky a požadavky</h2>
              <p class="mobitxt">&nbsp;</p>
            </div>
          </span>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Použitelnost</h2>
            <p class="mobitxt">
              Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou
              verzi jednorázové placené služby Miximo Premium (Puretech Global
              Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu
              od společnosti Puretech Global Sdn Bhd (dále dále jen Puretech
              Global Sdn Bhd). Koncový uživatel požaduje GAMEBOX Puretech Global
              Sdn Bhd.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Obvykle</h2>
            <p class="mobitxt">
              GAMEBOX poskytuje nejlepší sexy tapety a videa výhradně pro váš
              mobil.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Potvrzení / registrace</h2>
            <p class="mobitxt">
              Pro přístup ke službě GAMEBOX musí koncový uživatel zadat své
              mobilní telefonní číslo a / nebo určitá další data a / nebo
              informace prostřednictvím propagační webové stránky (úvodní
              stránky) provozované společností Puretech Global Sdn Bhd. Poté
              koncový uživatel obdrží na svůj server SMS mobilní zařízení, s
              osobním identifikačním číslem (PIN kód), nebo takzvanou nabídkovou
              zprávou s informacemi o službě. Koncový uživatel zadáním přijatého
              PIN kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a
              / nebo používáním služby potvrzuje a potvrzuje, že si přečetl
              Všeobecné podmínky, je autorizovaným majitelem účtu mobilního
              telefonu nebo má souhlas plátce telefonního účtu s využitím této
              služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné
              aktivaci služby GAMEBOX, způsobu, frekvenci a nákladech na
              převzetí Služby a také přesné údaje o odhlášení.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Náklady a poplatky</h2>
            <p class="mobitxt">
              GAMEBOX je placená služba, která stojí 3 SMS x 1,60 EUR / týden
              Poplatek bude účtován na účet mobilního telefonu nebo na
              předplacené mobilní číslo. Způsob účtování je Premium MT SMS
              zasílaná Koncovému uživateli na základě jeho požadavku na službu
              GAMEBOX. Tato zpráva bude obsahovat vaše přihlašovací údaje ke
              GAMEBOXU. Poplatky se vybírají podle provozovatelů mobilních sítí.
              Poplatky jsou odepsány na účet Koncového uživatele Provozovatelem;
              v případě SIM s předplatným jsou poplatky odečteny z kreditu
              Koncového uživatele. Koncový uživatel tímto výslovně uděluje své
              oprávnění účtovat poplatky a zavazuje se zaplatit v plné výši
              poplatky vzniklé v důsledku předplatného a / nebo používání služby
              GAMEBOX. Pokud nejste osobou odpovědnou za placení účtu za mobilní
              telefon, před přihlášením a / nebo používáním služby GAMEBOX si
              prosím vyžádejte povolení od svého mobilního plátce. Podpisem a /
              nebo účastí ve službě Puretech Global Sdn Bhd předpokládá, že
              koncový uživatel získal potřebné povolení, souhlas nebo schválení
              od plátce mobilního účtu, opatrovníka nebo rodičů. Všechny SMS
              zprávy zasílané koncovým uživatelem budou mobilním operátorem
              koncového uživatele účtovány za standardní tarif. Tyto sazby se
              mohou u jednotlivých operátorů lišit. Další informace o poplatcích
              vám poskytne váš mobilní operátor GSM.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Pomoc a podpora</h2>
            <p class="mobitxt">
              Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00
              Kontakt: +421 313215999 nebo gamebox.cz@silverlines.info
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Duševní vlastnictví</h2>
            <p class="mobitxt">
              Službu můžete používat pro osobní, nekomerční použití. Pojem
              GAMEBOX a všechny ostatní ochranné známky, servisní značky a /
              nebo obchodní názvy používané GAMEBOX ve Službě čas od času
              (ochranné známky) jsou ochranné známky, servisní značky a / nebo
              obchodní názvy společnosti Puretech Global Sdn Bhd nebo jedné z
              jejích společností v skupina nebo její poskytovatelé licencí a
              tyto subjekty si vyhrazují veškerá práva k ochranným známkám.
              Kromě toho další obsah Služeb, mimo jiné včetně her, obrázků,
              obrázků, grafik, fotografií, animací, videí, hudby, zvuku a textu,
              patří společnosti GAMEBOX nebo jedné z jejích společností a / nebo
              licencovaných skupin a jsou chráněny autorským právem a / nebo
              jinými právy duševního vlastnictví. Berete na vědomí, že
              používáním Služby nezískáte žádná práva na ochrannou známku ani
              Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných
              okolností nesmíte za žádných okolností kopírovat jakýkoli obsah
              služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo
              her), ani ve službě používat dolování dat, roboty, škrábance na
              obrazovce nebo podobné nástroje pro sběr a extrakci dat.
              Odpovědnost Používání GAMEBOXU a / nebo webových stránek GAMEBOXU
              je na vlastní riziko koncového uživatele. Koncový uživatel musí
              poskytnout kompatibilní mobilní telefon, hardware nebo jiné
              vybavení a software a zajistit, aby byly v provozuschopném stavu a
              vhodné pro služby GAMEBOX. GAMEBOX nemůže zaručit, že služby
              GAMEBOX splňují požadavky koncového uživatele a že stahování,
              příjem a / nebo prohlížení služeb GAMEBOX proběhne bez přerušení
              nebo chyb. Pokud kdykoli koncový uživatel nemůže bez přerušení
              používat službu Puretech Global Sdn Bhd, nevede to v žádném
              případě k právu na snížení poplatků za služby GAMEBOX, k
              jakémukoli právu na vrácení předplacených plateb. Jakékoli použití
              služeb GAMEBOX je na uvážení a riziku koncového uživatele, a to
              bez omezení, ale nikoli výhradně, infekce nebo kontaminace, ztráta
              dat nebo poškození hardwaru a / nebo softwaru koncových uživatelů
              v důsledku přístup k Webovým stránkám, nebo používání Služeb
              GAMEBOX, nebo stažené Služby GAMEBOX, včetně hardwaru a softwaru
              nutného pro připojení ke Službám GAMEBOX. Je odpovědností
              koncových uživatelů, aby přijali nezbytná opatření, která zabrání
              možnému poškození tohoto druhu. V případě, že je společnost
              GAMEBOX z jakéhokoli důvodu povinna odškodnit koncového uživatele
              za přímé nebo následné škody jakéhokoli druhu, nesmí taková
              náhrada v žádném případě překročit hodnotu faktury za služby
              GAMEBOX zaplacené koncovým uživatelem za údajné škody. Obsah
              webových stránek byl sestaven s největší péčí. Miximo však nemůže
              poskytnout žádnou záruku, pokud jde o povahu, přesnost nebo obsah
              těchto informací. GAMEBOX neodpovídá za žádné chyby, opomenutí,
              nepřesnosti, nedorozumění, zpoždění nebo nečitelné objednávky nebo
              oznámení založená na používání internetu nebo příslušného
              informačního bodu. Závěrečná ustanovení Veškeré spory týkající se
              plnění těchto Obchodních podmínek budou řešit příslušné obecné
              soudy. Puretech Global Sdn Bhd si vyhrazuje právo čas od času tyto
              podmínky změnit. Změny budou koncovým uživatelům oznámeny
              zveřejněním na portálu GAMEBOX.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: mapGetters(["host_gamebox", "countryCode"]),
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/gamebox/TermsCzech.vue